import { AwsRum } from 'aws-rum-web';

const guestRoleArn = process.env.REACT_APP_AWS_APP_RUM_GUEST_ROLE_ARN;
const identityPoolId = process.env.REACT_APP_AWS_APP_RUM_IDENTITY_POOL_ID;
const APPLICATION_ID = process.env.REACT_APP_AWS_APP_RUM_APPLICATION_ID;
const APPLICATION_VERSION = '1.0.0';
const APPLICATION_REGION = 'us-east-1';
const endpoint = 'https://dataplane.rum.us-east-1.amazonaws.com';
const telemetries = ['performance', 'errors', ['http', { recordAllRequests: true, addXRayTraceIdHeader: true }], 'interaction'];

let awsRumInstance;

export default function AwsCWRum (awsRum) {
    try {
        const config = {
            sessionSampleRate: 1,
            guestRoleArn,
            identityPoolId,
            endpoint,
            telemetries,
            allowCookies: true,
            enableXRay: false,
            // allowedDomains: [`http://localhost`, 'http://127.0.0.1']
        };

        awsRum = new AwsRum(
            APPLICATION_ID,
            APPLICATION_VERSION,
            APPLICATION_REGION,
            config
        );
        awsRumInstance = awsRum;
        return awsRum;
    }
    catch (error) {
        // Ignore errors thrown during CloudWatch RUM web client initialization
    }
}

export function logCustomEvent (eventType, attributes = {}) {
    if (awsRumInstance) {
        awsRumInstance.recordEvent(eventType, attributes);
    }
    else {
        console.warn('AWS RUM is not initialized, the event could not be recorded.');
    }
}
